import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFocalPoint32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFocalPoint32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 7a2 2 0 0 0-2 2v3.5a1 1 0 1 1-2 0V9a4 4 0 0 1 4-4h3.5a1 1 0 1 1 0 2zm16 2a2 2 0 0 0-2-2h-3.5a1 1 0 1 1 0-2H23a4 4 0 0 1 4 4v3.5a1 1 0 1 1-2 0zm0 14a2 2 0 0 1-2 2h-3.5a1 1 0 1 0 0 2H23a4 4 0 0 0 4-4v-3.5a1 1 0 1 0-2 0zM7 19.5V23a2 2 0 0 0 2 2h3.5a1 1 0 1 1 0 2H9a4 4 0 0 1-4-4v-3.5a1 1 0 1 1 2 0m9-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFocalPoint32);
